module.exports = __webpack_public_path__ + "static/media/file_copy_24.382fa613.svg";